export class DateRangeReq{
    fromDate?:any;
    toDate?:any;
    supplierId?:number;
    buyerId?:number;
    year?:number;
    gradeMaxCount?:number;
    gradeMinCount?:number;
    status?:string;
}